import { PackagingButtonQR } from './ButtonQR';

export const ButtonQR = PackagingButtonQR;
